module.exports = __webpack_public_path__ + "img/RX-RAD-DIGI-Sala-8-zoom.9a5a57ff.png";